/*
 * @Author: chenhui@didichuxing.com
 * @Date: 2018-12-17
 * @Description:  x推c落地页首页
 */
<template>
  <div class="xtc-container">
    <template v-if="configInfo && configInfo.recommendCode">
      <!-- 最新样式（包含页面所有元素）-->
      <template v-if="isStyleNew">
        <div class="xtc-container-main">
          <!-- banner -->
          <RecommendBanner
          :isOpenHorseLamp="isOpenHorseLamp"
          :horseLampData="horseLampData"
          :list="focusImg"
          :showMyRewardsHistory="showMyRewardsHistory"
          @gotoRewardList="gotoRewardList(true)"
          />
          <!-- reward process -->
          <!-- 阶梯奖励无默认奖励 -->
          <div v-if="isLadderNoDefault" class="xtc-reward-precess-nodefault">
            <GroupMvpProcess
            :country="country"
            :data="configInfo.recommendPage"
            :activityID="configInfo.activityID"
            :recommendCode="configInfo.recommendCode"
            :copyContent="copyContent"
            :shareConfig="shareConfig"
            @trackShareButtonClick="trackShareButtonClick"
            />
          </div>
          <div v-else-if="configInfo.recommendPage.ladderRule" class="xtc-reward-process">
            <div class="xtc-reward-process-title">{{_('奖励进度')}}</div>
            <div v-if="configInfo.recommendPage.ladderRule" >
              <RewardProcess :processData="configInfo.recommendPage.ladderRule" :currentProcess="configInfo.recommendPage.currentProgress" :activityID="configInfo.activityID"></RewardProcess>
            </div>
          </div>
          <!-- 分享区域 -->
          <div class="xtc-share-area">
            <!-- 分享区域-主副标题 -->
            <ShareTitle
            :mainTitle="mainTitle"
            :subTitle="subTitle"
            />
            <!-- 分享区域-button组 -->
            <div class="xtc-share-buttons">
              <ShareButtonCode
              :recommendCode="configInfo.recommendCode"
              :copyContent="copyContent"
              :clipboard="clipboard"
              @copyHandle="copyHandle"
              />
              <ShareButtonLocalChannel
              :config="shareConfig" 
              @trackShareButtonClick="trackShareButtonClick"
              />
              <ShareButtonOtherChannel
              :config="shareConfig" 
              @trackShareButtonClick="trackShareButtonClick"
              />
              <ShareTeach :country="country" :showLightTheme="isLadderNoDefault" />
            </div>
          </div>
          <!-- 本活动奖励区域 -->
          <RewardMyMvp v-if="isLadderNoDefault" @click="gotoRewardList" :info="configInfo"/>
          <PresentRewardMy v-else @click="gotoRewardList" :info="configInfo"/>
          <!-- 活动规则 -->
          <RuleDetailDialog v-if="showRules" />
          <!-- 挽留弹窗 (一天一次+配置了弹窗+点击返回)弹窗 introduction执行返回 invite停留在页面 -->
          <RecommendAlertDialog
          v-if="showAlertDialog"
          :country="country"
          :title="alertTitle"
          @close="closeAlertDialog" />
        </div>
      </template>
      <!-- 原有样式 -->
      <template v-else>
        <div class="xtc-container-main">
          <div class="banner">
          <p class="history" @click="gotoRewardList(true)" v-if="configInfo.recommendPage.ladderRule">{{_('我的奖励')}}</p>
          <rich-slide ref="slide" :data="focusImg">
            <rich-slide-item v-for="(item, index) in focusImg" :key="index" @click.native="clickHandler(item, index)">
              <div class="slide-item">
                <span class="mainTitle">{{item.title}}</span>
                <span class="subTitle">{{item.subTitle}}</span>
                <img :src="item.url">
              </div>
            </rich-slide-item>
            <template slot="dots" slot-scope="props">
              <template v-if="props.dots.length > 1">
                <span class="my-dot"
                  :class="{active: props.current === index}"
                  v-for="(item, index) in props.dots"
                  :key="index"
                >{{index + 1}}</span>
              </template>
              <span class="my-dot" v-else style="display:none"></span>
            </template>
          </rich-slide>
        </div>
        <div class="reward">
          <div class="reward-processing">
            <p class="reward-processing-title">{{configInfo.recommendPage.ladderRule ? _('奖励进度') : _('我的奖励')}}</p>
            <div class="reward-processing-ladder" v-if="configInfo.recommendPage.ladderRule" >
              <LadderReward :processData="configInfo.recommendPage.ladderRule" :currentProcess="configInfo.recommendPage.currentProgress" :activityID="configInfo.activityID"></LadderReward>
            </div>
          </div>
          <div class="reward-finished">
            <RewardTotal @click="gotoRewardList" :info="configInfo"></RewardTotal>
          </div>
        </div>
          <div class="share">
            <div class="code-box">
              <p class="code-box-title">{{_('通过SNS邀请')}}</p>
              <div class="copy-wrap">
                <span class="code">{{configInfo.recommendCode}}</span>
                <span
                  v-if="clipboard"
                  class="copy-btn"
                  :data-clipboard-text="copyContent"
                  @click="copyHandle"
                >
                </span>
              </div>
            </div>
            <div class="share-box">
              <div class="title">{{gettext('将优惠分享到')}}</div>
              <share :config="shareConfig" :shortLink="true" @trackShareClick="trackShareClick" />
            </div>
          </div>
          <div class="rules" v-if="showRules">
            <div class="line-wrap">
              <span class="line l"></span>
              <span class="text">{{gettext('规则详情')}}</span>
              <span class="line r"></span>
            </div>
            <Rules></Rules>
          </div>
        </div>
      </template>
    </template>
    <template v-if="pageError">
      <div class="xtc-container-main">
        <div class="banner">
          <div class="errStatus" :style="{'background-image': bannerBg}"></div>
        </div>
        <div class="reward">
          <div class="reward-processing">
            <p class="reward-processing-title">{{_('我的奖励')}}</p>
          </div>
          <RewardTotal @click="gotoRewardList(true)" :info="amountInfo"></RewardTotal>
        </div>
        <p class="no-activity-msg">{{_('当前无有效活动')}}</p>
      </div>
    </template>
    <loading-mask v-show="loading"></loading-mask>
  </div>

</template>

<script>
import RewardMyMvp from './landingPage/reward_my_mvp'
import GroupMvpProcess from './landingPage/group_mvp_process'
import RewardProcess from './landingPage/reward_process'
import RecommendAlertDialog from './landingPage/recommend_alert_dialog'
import RuleDetailDialog from './landingPage/rule_detail'
import ShareTeach from './landingPage/share_teach'
import PresentRewardMy from './landingPage/reward_my'
import ShareButtonLocalChannel from './landingPage/share_button_local_channel'
import ShareButtonOtherChannel from './landingPage/share_button_other_channel'
import ShareButtonCode from './landingPage/share_button_code'
import ShareTitle from './landingPage/share_title'
import RecommendBanner from './landingPage/recommend_banner'
import Clipboard from 'clipboard'
import RewardTotal from './modules/reward-total.vue'
import { debounce, getUrlLanguage, checkIsOldVersion, getAmountTmpl, getIntNumFromAmount } from '@/common/js/utils'
import { getShareConfig } from './utils'
import Share from './modules/share.vue'
import { mapGetters, mapActions } from 'vuex'
import { getLocale } from '@didi/gettext'
import trackEvent from '@/common/js/track'
import { setTitle } from '@/common/js/bridge'
import getCountryConfig from '@/common/config/country-config'
import API from '@/api'
import LoadingMask from '@/components/loading/loading-mask'
import { util } from '@didi/soda-common'
import PerformanceTool from '@didi/soda-fe-performance-tool'
import Rules from './detailRules'
import LadderReward from './modules/ladder-reward1'
import loginMixin from '@/common/mixin/login'
const { env } = util
const REWARD_TYPE_LADDER_NODEFAULT = 1

export default {
  name: 'landingPage',
  mixins: [loginMixin],
  data () {
    return {
      horseLampData: [],
      showAlertDialog: false,
      isLogin: false,
      configInfo: {},
      clipboard: null,
      shareConfig: {
        config: {},
        order: []
      },
      focusImg: [],
      activityType: 'CC',
      pageError: false,
      amountInfo: {},
      loading: true,
      isSupport: false,
      copyContent: ''
    }
  },
  components: {
    RewardMyMvp,
    GroupMvpProcess,
    RewardProcess,
    RecommendAlertDialog,
    RuleDetailDialog,
    ShareTeach,
    PresentRewardMy,
    ShareButtonLocalChannel,
    ShareButtonOtherChannel,
    ShareButtonCode,
    ShareTitle,
    RecommendBanner,
    RewardTotal,
    Share,
    LoadingMask,
    Rules,
    LadderReward
  },
  computed: {
    ...mapGetters({
      globalParams: 'globalParams',
      acquisitionInfo: 'acquisitionInfo'
    }),
    rewardType () {
      const recommendPage = this.configInfo.recommendPage || {}
      const { rewardType } = recommendPage
      return rewardType
    },
    isLadderNoDefault () {
      const recommendPage = this.configInfo.recommendPage || {}
      const { rewardType } = recommendPage
      return rewardType === REWARD_TYPE_LADDER_NODEFAULT
    },
    isLadderNoDefaultIng () {
      const recommendPage = this.configInfo.recommendPage || {}
      const { currentProgress, totalLadderNum } = recommendPage
      return currentProgress < totalLadderNum
    },
    // start --- 2022.04.26 CGC-活动页改版
    // 是否有跑马灯
    isOpenHorseLamp () {
      const { openHorseLamp } = this.configInfo.recommendPage
      return openHorseLamp
    },
    // 是否有挽留弹窗
    isOpenAlert () {
      return this.configInfo && this.configInfo.recommendPage && this.configInfo.recommendPage.openAlert
    },
    alertTitle () {
      const isLadder = !!this.configInfo.recommendPage.ladderRule
      // let translate = '还有{{x}}金额待领取'
      let translate = this._('FoodC_CGC_There_is_gZQn' /** 还有{{x}}金额待领取 */)
      const { rewardInfo, ladderAmountSplit } = this.configInfo.recommendPage
      const amount = isLadder
        ? ((ladderAmountSplit && ladderAmountSplit.display) || '')
        : ((rewardInfo && rewardInfo.amountSplit && rewardInfo.amountSplit.display) || '')
      return translate.replace('{{x}}', amount)
    },
    mainTitle () {
      const { share } = this.configInfo.recommendPage
      const mainTitle = share && share.mainTitle
      return mainTitle
    },
    subTitle () {
      const { share } = this.configInfo.recommendPage
      const subTitle = share && share.subTitle
      return subTitle
    },
    showMyRewardsHistory () {
      const {ladderRule} = this.configInfo.recommendPage
      return !!ladderRule
    },
    isStyleNew () {
      // styleOption 1 原有样式 2 最新样式
      return this.configInfo && this.configInfo.recommendPage && this.configInfo.recommendPage.styleOption && this.configInfo.recommendPage.styleOption === 2
    },
    // end --- 2022.04.26 CGC-活动页改版

    // 2021.12.01qw-哥斯达黎加临时下线T&C，待确认后再修改
    // 单纯排除哥斯达黎加(CR), 若country为空走之前逻辑
    // 2022.03.03qw-哥伦比亚临时下线T&C
    showRules () {
      return !(this.country === 'CR' || this.country === 'CO')
    },
    country () {
      return this.$store.state.country
    },
    brand () {
      return this.$store.state.brand
    },
    hostName () {
      const { country } = this.$store.state
      // 巴西使用99域名,墨西哥使用didi域名
      return GlobalConfig[country].hostname || 'act.didi-food.com'
    },
    // 根据不同国家展示不同优惠券背景占位图
    bannerBg () {
      return `url(${getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['C_BANNER_BG']})`
    },
    rewardedReward () {
      return this.rewardAmountTemplate(this.configInfo.rewardedAmountSplit)
    },
    pendingReward () {
      return this.rewardAmountTemplate(this.configInfo.pendingAmountSplit)
    }
  },
  methods: {
    ...mapActions({
      getGlobalInfo: 'getGlobalInfo',
      getAcquisitionInfo: 'getAcquisitionInfo',
      getHorseLampData: 'getHorseLampData' // cgc-活动页改版-跑马灯数据
    }),
    closeAlertDialog () {
      this.showAlertDialog = false
      try {
        this.SodaBridge('setBackPressListener', false)
      } catch (e) {}
    },
    // api请求时间埋点
    trackApi (requestStart, responseData) {
      let requestEnd = new Date().getTime()
      trackEvent({
        eventId: 'sailing_act_xtc_api_request_timing',
        eventLabel: 'X推C活动API请求时长',
        attrs: {
          window_type: this.type,
          router: this.$route.fullPath,
          pageEnterTiming: window.performance.timing.navigationStart,
          ApiRequestStartTiming: requestStart,
          ApiRequestEndTiming: requestEnd,
          ApiRequestiming: requestEnd - requestStart,
          firstPageTiming: requestEnd - window.performance.timing.navigationStart,
          responseData: responseData
        }
      })
    },
    trackShareClick (plantform) {
      trackEvent({
        eventId: 'sailing_c_x_invitation_share_ck',
        eventLabel: 'X推C落地页-分享',
        attrs: {
          share_channel: plantform,
          from_page: this.activityType,
          activity_id: this.configInfo.activityID || '',
          invite_code: this.configInfo.recommendCode
        }
      })
    },
    pageInit () {
      this.initClipBoard()
      this.getGlobalInfo()
        .then((data) => this.fetchAcquisitionInfo(data))
        .catch(err => {
          const toast = this.$createToast({
            time: 3000,
            txt: err,
            type: 'error'
          })
          toast.show()
        })
    },
    clickHandler (item, index) {
      // console.log(item, index)
    },
    initClipBoard () {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard('.copy-btn')
      }
    },
    getAppLinkCode () {
      return getCountryConfig.appLinkUrl.APPLINKURL_CODE(this.brand)
    },
    async fetchHorseLampData () {
      try {
        let res = await this.getHorseLampData({activityId: this.configInfo.activityID})
        const {errno, data} = res
        if (errno === 0) {
          this.horseLampData = data
        }
      } catch (err) {}
    },
    async fetchAcquisitionInfo (data) {
      if (data.phone && !this.isLogin) {
        this.isLogin = true
        // 这里是进行上报用户登录成功
        trackEvent({
          eventId: 'tone_p_x_login_success',
          eventLabel: '用户登录成功',
          attrs: {
            phone: data.phone
          }
        })
      }
      let poiLat = data.poiLat || data.lat
      let poiLng = data.poiLng || data.lng
      let requestStart = new Date().getTime()

      try {
        let res = await this.getAcquisitionInfo({token: data.token, activityType: this.activityType, poiLat: poiLat, poiLng: poiLng})
        this.trackApi(requestStart, res.data)
        if (res && res.errno === 0 && res.data) {
          this.configInfo = res.data
          this.focusImg = this.configInfo.recommendPage.focusImg.list
          this.getCopyContent()
          /**
           * 如果是兑换码类型。则直接配置onelink链接去掉中间兑换码被推荐人页面
           * 如果是手机号类型则保持原有逻辑
           * type:1 手机号类型 2兑换码类型
           * */
          if (this.configInfo.recommendPage.share.type === 1) {
            this.configInfo.recommendPage.share.url =
            `${window.location.protocol}//${window.location.host}/${getUrlLanguage()}/c/participateShare?share=1&code=${this.configInfo.recommendCode}&activityType=${this.activityType}&activityId=${this.configInfo.activityID}&poiLat=${poiLat}&poiLng=${poiLng}&countryCode=${this.country}`
          } else {
            this.configInfo.recommendPage.share.url =
            `${this.getAppLinkCode()}?code=${this.configInfo.recommendCode}&activityType=1&locale=${getLocale()}`
          }
          let recommendPage = this.configInfo.recommendPage || {}
          this.shareConfig.config = await getShareConfig(
            recommendPage.share,
            recommendPage.share.url,
            recommendPage.shareOrder,
            this.configInfo.recommendPage.share.type === 1
          )
          // 根据服务端下发展示顺序过滤用户侧主面板所展示的分享渠道
          this.shareConfig.order = recommendPage.shareOrder
          // 若配置跑马灯，根据activityId获取跑马灯数据
          if (this.isOpenHorseLamp) {
            this.fetchHorseLampData()
          }
          setTitle(this.configInfo.recommendPage.title)
          if (!PerformanceTool.isReported) {
            setTimeout(() => {
              trackEvent({
                eventId: 'sailing_act_x_xgc_home_load_timing',
                eventLabel: '推荐有奖页面首屏时间',
                attrs: {
                  ...PerformanceTool.getPerformanceCommonParams()
                }
              })
              trackEvent({
                eventId: 'sailing_act_x_xgc_static_resource_load_timing',
                eventLabel: '推荐有奖页面静态资源',
                attrs: {
                  ...PerformanceTool.getStaticResourceDownloadParams()
                }
              })
            })
          }
          trackEvent({
            eventId: 'sailing_c_x_invitation_common_sw',
            eventLabel: '推荐有奖领取页面展示',
            attrs: {
              activity_status: 1, // 因为后端无法给出活动状态，故暂时只传1
              from_page: this.activityType || '',
              activity_id: this.configInfo.activityID || '',
              rewarded: (this.configInfo && this.configInfo.rewardedAmount) || 0,
              pending: (this.configInfo && this.configInfo.pendingAmount) || 0,
              invite_code: this.configInfo.recommendCode
            }
          })
        } else if (res && res.errno) {
          trackEvent({
            eventId: 'sailing_c_x_invitation_common_sw',
            eventLabel: '推荐有奖领取页面展示',
            attrs: {
              activity_status: 0, // 因为后端无法给出活动状态，故后端返回0时，都算0
              from_page: this.activityType || '',
              activity_id: this.configInfo.activityID || '',
              rewarded: (this.configInfo && this.configInfo.rewardedAmount) || 0,
              pending: (this.configInfo && this.configInfo.pendingAmount) || 0
            }
          })
          this.pageError = true
          this.onFetchlist()
          // throw res && res.errmsg
        }
      } catch (e) {
        trackEvent({
          eventId: 'sailing_c_x_invitation_common_swerror',
          eventLabel: '推荐有奖领取页面展示失败',
          attrs: {
            error_info: e
          }
        })
      }
      this.loading = false
    },
    copyHandle: debounce(function () {
      trackEvent({
        eventId: 'sailing_c_x_invitation_copy_ck',
        eventLabel: '点击你的邀请码旁边的复制按钮',
        attrs: {
          from_page: this.activityType || '',
          activity_id: this.configInfo.activityID || '',
          invite_code: this.configInfo.recommendCode
        }
      })
      this.clipboard.on('success', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('复制成功'),
          type: 'correct'
        })
        toast.show()
        e.clearSelection()
      })
      this.clipboard.on('error', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: this.gettext('该浏览器不支持自动复制'),
          type: 'error'
        })
        toast.show()
        e.clearSelection()
      })
    }, 200),
    // 异常态后兜底取奖励历史数据
    fetchAcquisitionReferralList (data) {
      return API.acquisitionReferralList(data)
        .then((res) => {
          if (res && res.errno === 0 && res.data) {
            return res.data
          } else {
            throw res && res.errmsg
          }
        })
        .catch(err => {
          const toast = this.$createToast({
            time: 3000,
            txt: err,
            type: 'error'
          })
          toast.show()
        })
    },
    onFetchlist () {
      return new Promise((resolve, reject) => {
        this.fetchAcquisitionReferralList({
          token: this.globalParams.token,
          poiLng: this.globalParams.poiLng,
          poiLat: this.globalParams.poiLat,
          activityId: 0,
          activityType: this.activityType,
          page: 1,
          pageSize: 1
        }).then((res) => {
          this.amountInfo = res
        })
      })
    },
    rewardAmountTemplate (amountSplit) {
      let solvedSplit = {
        'symbol': amountSplit.symbol,
        'number': getIntNumFromAmount(amountSplit.number),
        'position': amountSplit.position,
        'display': amountSplit.display,
        'sign': amountSplit.sign
      }
      if (amountSplit) {
        const splitData = {
          split: solvedSplit,
          symbolClass: 'symbol',
          numberClass: 'amount'
        }
        return getAmountTmpl(splitData)
      }
      return ''
    },
    gotoRewardList (isHistory) {
      let query = {}
      if (!isHistory) {
        query = {
          activityId: this.configInfo.recommendPage.ladderRule ? this.configInfo.activityID : ''
        }
        if (this.rewardType === REWARD_TYPE_LADDER_NODEFAULT) {
          query.rewardType = 'mvp'
        }
      } else {
        trackEvent({
          eventId: 'sailing_c_x_invitation_reward_detail_ck',
          eventLabel: '点击奖励',
          attrs: {
            from_page: this.activityType || '',
            activity_id: this.configInfo.recommendPage.ladderRule ? this.configInfo.activityID : ''
          }
        })
      }
      this.$router.push({
        path: `/c/rewardlist`,
        query
      })
    },
    async getCopyContent () {
      if (this.configInfo.recommendPage) {
        let shortLink = await this.getShortLink(`https://${this.hostName}/${getUrlLanguage()}/c/participateShare?share=1&code=${this.configInfo.recommendCode}&activityType=${this.activityType}&activityId=${this.configInfo.activityID}&countryCode=${this.country}`)
        this.copyContent = `${this.configInfo.recommendPage.share.referralCode}${shortLink}`
      }
    },
    async getShortLink (shareUrl) {
      let shortLinkKey = this.country === 'BR' ? 'short_url_99' : 'short_url'
      let res = await API.getShortLink({url: shareUrl})
      return res.data ? res.data[shortLinkKey] : ''
    },
    // start --- 2022.04.26 CGC-活动页改版
    trackShareButtonClick (buttonType) {
      trackEvent({
        eventId: 'sailing_c_x_invitation_share_button_ck',
        eventLabel: 'X推C落地页-分享按钮',
        attrs: {
          // share_channel: plantform,
          // from_page: this.activityType,
          activity_id: this.configInfo.activityID || '',
          invite_code: this.configInfo.recommendCode,
          button_type: buttonType // 1 立即邀请 2 其他渠道
        }
      })
    }
    // end --- 2022.04.26 CGC-活动页改版
  },
  async created () {
    setTitle(this.gettext('推荐有奖'))
    let globalParams = await this.SodaBridge('getGlobalParams', 'badcase') || {}
    const { appVersion } = globalParams.data
    let clientVersion = null // 独立端 or 嵌入端版本号
    clientVersion = !env.inSoda ? '7.1.56' : '1.0.22'
    // 独立端1.0.22以下版本，嵌入端7.1.56以下版本的不支持推特分享
    this.isSupport = !checkIsOldVersion(appVersion, clientVersion)
    this.getTokenToLogin(this.pageInit)
  },
  mounted () {
    try {
      setTimeout(() => {
        if (this.isOpenAlert) {
          this.SodaBridge('setBackPressListener', true).then(() => {
            this.showAlertDialog = true
          })
        }
      }, 3000)
    } catch (e) {}
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy()
    try {
      this.SodaBridge('setBackPressListener', false)
    } catch (e) {}
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/common/stylus/variables";
@import "~@/assets/styles/main.scss";
@import '~@/common/stylus/mixin.styl';
.xtc-container {
  display: flex
  flex-direction: column
  justify-content: space-between
  flex-wrap: nowrap
  background: #f7f7f7
  width: 100%
  height: 100%
  overflow-x: hidden
  overflow-y: auto
  hide-scrollbar()
  &-main {
    width: 100%
    .banner {
      margin-bottom: 18px;
      overflow: hidden
      width: 100%
      max-height: 430px;
      background-color: #f5f5f5
      position relative
      .slide-item {
        max-height: 430px;
        position: relative
        .mainTitle {
          display: none
          position: absolute
          left: 10px
          bottom: 50px
        }
        .subTitle {
          display: none
          position: absolute
          left: 10px
          bottom: 10px
          font-size: 28px
        }
        img {
          width: 100%
        }
      }
      .rich-slide-dots {
        .my-dot {
          width: 20px
          height: 4px
          opacity: 0.24
          background: #FFFFFF
          border-radius: 4px
        }
        .active {
          width: 20px
          opacity: 0.66
        }
      }
      .errStatus {
        overflow: hidden
        width: 100%
        height: 430px
        background-size: 100%;
        text-align: center
        strong{
          margin: 200px auto 0
          display: block
        }
      }
      .history {
        position absolute
        z-index 10
        right 0
        top 25px
        padding 0 24px
        height 56px
        line-height 56px
        opacity: 0.36;
        background: #000000;
        border-radius: 8px 0 0 8px;
        font-family: 'Aspira Medium';
        font-size: 28px;
        color: #FFFFFF;
        text-align: left;
        text-shadow: 0 0 24px rgba(0,0,0,0.36);
      }
    }
    .reward {
      margin: 20px 24px
      padding: 32px 0
      border-radius: 12px
      background: #ffffff
      .reward-processing {
        font-family: 'Aspira Light'
        font-size: 28px
        color: #000000
        text-align: left
        .reward-processing-ladder {
          padding-bottom 34px
          border-bottom 1px solid #EBEBEB
        }
      }
      .reward-processing-title {
        padding 0 32px
      }
    }
    .share {
      margin: 20px 24px
      padding: 48px 0
      border-radius: 12px
      background: #ffffff
      .code-box {
        margin 0 32px;
        padding-bottom 48px
        border-bottom 1px solid #EBEBEB

        .code-box-title {
          font-family: 'Aspira Light';
          font-size: 28px;
          color: #000000;
          text-align: left;
        }
        .copy-wrap {
          margin-top: 48px;
          display flex
          align-items center
          justify-content flex-start
          .copy-btn {
            display: inline-block
            width: 40px
            height: 40px
            line-height: 40px
            white-space: nowrap
            copy-icon()
            margin-left: 12px
            box-sizing: border-box
            font-size: 28px
            font-color()
          }
          .code {
            font-family: 'Aspira Medium'
            font-size: 48px
            color: #000000
            letter-spacing: 0
            text-align: center
            font-weight: bold
            -webkit-user-select: text
          }
        }
      }
      .share-box {
        margin 48px 32px 0
        .title {
          font-family: 'Aspira Light';
          font-size: 28px;
          color: #000000;
          text-align: left;
          margin-bottom 18px
        }
        & /deep/ .icons {
          padding 0
          justify-content space-between
          .icon {
            width 90px
            height 90px
            margin-left 0
            img {
              width 90px
              height 90px
            }
          }
        }
      }
    }
    .rules {
      padding-top 80px
      .line-wrap {
        display: flex
        justify-content: center
        .line {
          display: block
          width: 146px
          height: 2px
          margin-top: 14px
          &.r  {
            background: linear-gradient(to right, #B8B8B8, #ffffff)
            margin-left: 24px;
          }
          &.l {
            background: linear-gradient(to right, #ffffff, #B8B8B8)
            margin-right: 24px
          }
        }
        .text {
          font-family: 'Aspira Regular';
          font-size: 28px;
          color: #666666;
          text-align: left;
        }
      }
    }
    .no-activity-msg {
      margin-top 68px
      text-align center
      font-family 'Aspira Light'
      font-size 32px
      color #666666
    }
  }
  // 新版xtc样式拆解
  .xtc-reward-precess-nodefault {
    margin: 0 24px 20px 24px;
  }
  .xtc-reward-process {
    margin: 0 24px 20px 24px;
    padding-top: 32px;
    width: 702px;
    height: 334px;
    background: #FFFFFF;
    border-radius: 12px;
    .xtc-reward-process-title {
      margin-left: 32px;
      height: 36px;
      // font-family: DiDiSansPro-Medium;
      font-family: Aspira Medium;
      font-size: 36px;
      color: #000000;
      font-weight: 500;
    }
  }
  .xtc-share-area {
    margin: 0 24px 0 24px;
    padding: 32px 32px 40px;
    width: 638px;
    // height: 728px;
    background: #FFFFFF;
    border-radius: 12px; 
  }
}
</style>
